module.exports = __webpack_public_path__ + "img/cert-familyfriendly-2020.0dd9b5b1.png";